<template>
  <div class="card mb-4">
    <h5 class="card-header">Dialer — Recent Attempts</h5>
    <div class="card-body">
      <LoadingIndicator v-if="loading" centered />
      <span v-if="!loading && !items.length">No call attempts yet</span>
      <table class="table" v-if="!loading && items.length">
        <thead class="table">
          <tr>
            <th scope="col">Lead</th>
            <th scope="col">Customer</th>
            <th scope="col">Phone</th>
            <th scope="col">Result</th>
            <th scope="col">Attempted at</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.attemptId">
            <td>
              <b-link :to="orderLink(item)" target="_blank">#{{ item.leadId }}</b-link>
            </td>
            <td>{{ item.customerName || '-' }}</td>
            <td>{{ item.customerPhone || '-' }}</td>
            <td>{{ item.resultTitle || 'In progress…' }}</td>
            <td>{{ item.attemptedAt | formatDateTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator';
import permissionsMixin from '/src/mixins/permissions';

export default {
  name: 'Dialer',
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  mixins: [permissionsMixin],
  components: {
    LoadingIndicator,
  },
  async created() {
    this.fetchAttempts();
  },
  methods: {
    async fetchAttempts() {
      this.loading = true;
      const response = await ApiClient.softphone.recentAttempts({});
      this.items = response.data.data;
      this.loading = false;
    },
    orderLink(item) {
      if (item.leadTypeId == 3) return { name: 'OrderDetails', params: { id: item.leadId } };
      if (item.leadTypeId == 2) return { name: 'QuoteDetails', params: { id: item.leadId } };
      if (item.leadTypeId == 1) return { name: 'LeadDetails', params: { id: item.leadId } };
      return null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
